import { orchestrator } from 'satcheljs';
import { onSurfaceDoubleClick } from '../actions/surfaceOnClickActions';
import { executeCommand } from 'owa-calendar-command-executor';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import {
    getCalendarEntries,
    getCalendarIdByFolderId,
    isWritableCalendar,
} from 'owa-calendar-cache';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { lazyOpenCalendarFullCompose } from 'owa-calendar-compose-form-lifecycle';

/**
 * Opens the full-compose for creating a new event
 *
 */
orchestrator(onSurfaceDoubleClick, actionMessage => {
    const datapoint = returnTopExecutingActionDatapoint();
    datapoint.addCustomData({ currentDateRangeType: getSurfaceStore().dateRangeType });

    let initialCalendarEvent: Partial<CalendarEvent> = {
        Start: actionMessage.start,
        End: actionMessage.end,
        IsAllDayEvent: actionMessage.isAllDay,
    };

    // add the ParentFolderId if provided, so that FullCompose shows up for that calendar
    if (actionMessage.selectedCalendarFolderId) {
        let selectedCalendarId = getCalendarIdByFolderId(actionMessage.selectedCalendarFolderId);
        let calendar = getCalendarEntries().filter(
            c => c.calendarId.id == selectedCalendarId.id
        )[0];
        // assign only if provided calendar is a writable calendar
        if (calendar && isWritableCalendar(calendar)) {
            initialCalendarEvent.ParentFolderId = {
                Id: actionMessage.selectedCalendarFolderId,
                mailboxInfo: calendar.calendarId.mailboxInfo,
            };
        } else {
            // read only calendars should not display the FullCompose on double-click
            return;
        }
    }

    executeCommand(
        () =>
            lazyOpenCalendarFullCompose.importAndExecute({
                fullComposeEntrySource: 'Surface',
                eventUpdates: initialCalendarEvent,
            }),
        0
    );
});
